export default __webpack_public_path__ + "9edb2db2308390a8140fc01551d3d153.png";